package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.animation.Easing
import com.macrofocus.eflux.components.EFluxContext
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.network.line.Line
import com.macrofocus.eflux.network.substation.Substation
import emotion.react.css
import mui.base.AutocompleteChangeDetails
import mui.base.AutocompleteChangeReason
import mui.base.FilterOptionsState
import mui.material.Autocomplete
import mui.material.AutocompleteProps
import mui.material.AutocompleteRenderOptionState
import mui.material.TextField
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.locationtech.jts.legacy.Math
import org.mkui.react.useProperty
import react.*
import react.dom.events.SyntheticEvent
import react.dom.html.HTMLAttributes
import react.dom.html.ReactHTML.li
import react.dom.html.ReactHTML.span
import web.cssom.FontFamily
import web.cssom.FontSize
import web.cssom.FontStretch
import web.html.HTMLLIElement
import kotlin.math.exp

val Search: FC<*> = FC<Props> {
    val context = useRequired(EFluxContext)
    val theme = useTheme<Theme>()

    val dataLoader = context.dataLoader
    val (substationNetwork, _) = useProperty(dataLoader.substationNetwork)

    val customBackground: (SxProps<Theme>) -> Unit = { it ->
        it.blurBackground(theme)
    }

    val (options, setOptions) = useState<List<Any>>(emptyList())

    useEffect(substationNetwork, options) {
        if (substationNetwork != null && options.isEmpty()) {
            val list = ArrayList<Any>()
            if(substationNetwork != null) {
                for (substation in substationNetwork.nodes.sortedBy { option -> if(option.name != null) option.name else option.logicalBusId.name }) {
                    if(substation.logicalGeometry != null || substation.physicalGeometry != null) {
                        list.add(substation)
                    }
                }

                for (link in substationNetwork.links.sortedBy { option -> if(option.longName != null) option.longName else option.logicalBranchId.name }) {
                    if(link.logicalGeometry != null || link.physicalGeometry != null) {
                        list.add(link)
                    }
                }
            }
            setOptions(list)
        }
    }

    Autocomplete<AutocompleteProps<Any>> {
//                sx { width = 100.pct }
        fullWidth = true

        this.options = options.toTypedArray()
        disabled = options.isEmpty()

        autoComplete = true
        autoHighlight = true
        clearOnEscape = true

        freeSolo = true
//                disablePortal = true
        renderInput = { params ->
            TextField.create {
                +params
                label = ReactNode("Search")
            }
        }
        getOptionKey = { option ->
            if(option is Substation) {
                option.logicalBusId.name
            } else if(option is Line) {
                option.logicalBranchId.name
            } else {
                ""
            }
        }
        isOptionEqualToValue = { option, value ->
            if(option is Substation && value is Substation) {
                option.logicalBusId.name == value.logicalBusId.name
            } else if(option is Line && value is Line) {
                option.logicalBranchId.name == value.logicalBranchId.name
            } else {
                false
            }
        }

        getOptionLabel = { option ->
            if(option is Substation) {
                if(option.name != null) option.name!! else option.logicalBusId.name
            } else if(option is Line) {
                if(option.longName != null) option.longName!! else option.logicalBranchId.name
            } else {
                ""
            }
        }
        filterOptions =  { options: Array<out Any>, state: FilterOptionsState<Any> ->
            val inputValue = state.inputValue
            options.filter {
                val terms = inputValue.split('-', ' ')
                var result = true
                for (t in terms) {
                    if(it is Substation) {
                        result = result && (it.name?.contains(t, ignoreCase = true) ?: false || it.logicalBusId.name.contains(t, ignoreCase = true))
                    } else if(it is Line) {
                        result = result && (it.longName?.contains(t, ignoreCase = true) ?: false || it.logicalBranchId.name.contains(t, ignoreCase = true))
                    }
                }
                result
            }.toTypedArray()
        }

        renderOption = { props: HTMLAttributes<HTMLLIElement>,
                         option: Any,
                         state: AutocompleteRenderOptionState,
                         ownerState: AutocompleteProps<Any>
            ->
            li.create() {
                +props
                onMouseEnter = {
                    if(option is Substation) {
                        dataLoader.configuration.logicalBusProbing.setSelectedElement(option.logicalBusId)
                    } else if(option is Line) {
                        dataLoader.configuration.logicalBranchProbing.setSelectedElement(option.logicalBranchId)
                    }
                }
                onMouseLeave = {
                    dataLoader.configuration.logicalBusProbing.clearSelection()
                    dataLoader.configuration.logicalBranchProbing.clearSelection()
                }

                if(option is Substation) {
                    span {
                        css {
                            fontFamily = FontFamily.monospace
                            fontSize = FontSize.xxSmall
                            asDynamic().fontStretch = FontStretch.ultraCondensed
                        }
                        +(option.logicalBusId.name + " ")
                    }

                    css {
                        fontSize = FontSize.small
                        asDynamic().fontStretch = FontStretch.semiCondensed
                    }

                    +if(option.name != null) option.name else option.logicalBusId.name
                } else if(option is Line) {
                    span {
                        css {
                            fontFamily = FontFamily.monospace
                            fontSize = FontSize.xxSmall
                            asDynamic().fontStretch = FontStretch.ultraCondensed
                        }
                        +(option.logicalBranchId.name + " ")
                    }

                    css {
                        fontSize = FontSize.small
                        asDynamic().fontStretch = FontStretch.semiCondensed
                    }

                    +if(option.longName != null) option.longName else option.logicalBranchId.name
                }
            }
        }

//                value = getValue
        onChange = { event: SyntheticEvent<*, *>,
                     value: Any,
                     reason: AutocompleteChangeReason,
                     details: AutocompleteChangeDetails<Any>? ->
            println("onChange $value")
//                    dataLoader.configuration.pathProbing.selected = if(value is CombinedBranches) value.logicalBranchId else null
            if(value is Substation) {
//                        setValue(value.logicalBusId.name)
                dataLoader.overviewZoom(value.logicalGeometry, value.physicalGeometry)
                dataLoader.configuration.logicalBusSelection.setSelectedElement(value.logicalBusId)

//                        val physicalGeometry = value.physicalGeometry
//                        if(physicalGeometry != null) {
//                            val envelope = physicalGeometry.envelopeInternal
//                            val zoom = calculateZoomLevel(envelope.minX, envelope.minY, envelope.maxX, envelope.maxY, window.innerWidth, window.innerHeight, 0.25)
//
//                            val timeline = timeline {
//                                val duration: Long = 15000 / 2
//                                parallel {
//                                    property(dataLoader.threeDZoom, 11.0, duration, ZoomEasing())
//                                    val centroid = physicalGeometry.centroid
//                                    property(dataLoader.threeDLatitude, centroid.y, duration, Easing.QUAD_OUT)
//                                    property(dataLoader.threeDLongitude, centroid.x, duration, Easing.QUAD_OUT)
//                                    //                                property(dataLoader.threeDPitch, 60.0, duration, Easing.QUAD_IN)
//                                }
//                                parallel {
//                                    property(dataLoader.threeDZoom, zoom, duration, ZoomEasing())
//                                }
//                            }

//                            dataLoader.playback.value = Playback(timeline, DiagramType.ThreeD)
//                        } else {
//                            dataLoader.configuration.pointSelection.clearSelection()
//                        }
            } else if(value is Line) {
                dataLoader.overviewZoom(value.logicalGeometry, value.physicalGeometry)
                dataLoader.configuration.logicalBranchSelection.setSelectedElement(value.logicalBranchId)

//                        val physicalGeometry = value.physicalGeometry
//                        if(physicalGeometry != null) {
//                            val envelope = physicalGeometry.envelopeInternal
//                            val zoom = calculateZoomLevel(envelope.minX, envelope.minY, envelope.maxX, envelope.maxY, window.innerWidth, window.innerHeight, 0.1)
//
//                            val timeline = timeline {
//                                val duration: Long = 30000
//                                parallel {
//                                    property(dataLoader.threeDZoom, zoom, duration)
//                                    val centroid = physicalGeometry.centroid
//                                    property(dataLoader.threeDLatitude, centroid.y, duration)
//                                    property(dataLoader.threeDLongitude, centroid.x, duration)
//                                    //                                property(dataLoader.threeDPitch, 60.0, duration, Easing.QUAD_IN)
//                                }
//                            }
//
//                            dataLoader.playback.value = Playback(timeline, DiagramType.ThreeD)
//                        }
            } else {
                dataLoader.configuration.logicalBranchSelection.clearSelection()
            }
        }
    }
}

public class ZoomEasing2 : Easing {
    override fun ease(t: Double, b: Double, c: Double, d: Double): Double {
        val easedProgress = Easing.QUAD_IN_OUT.ease(t, 0.0, 1.0, d)  // Ease the progress

        // Perform logarithmic interpolation based on the eased progress
        val newZoom = lerpLog(b, c, easedProgress)
        return newZoom
    }

    // Logarithmic interpolation for exponential zoom
    fun lerpLog(start: Double, end: Double, t: Double): Double {
        val startLog = Math.log(start)
        val endLog = Math.log(end)
        return exp(startLog + (endLog - startLog) * t)
    }
}